import React from 'react';
import { VictoryLabel } from 'victory';

export const RoundedTickLabel = (props) => {
  const roundedTicks = [...new Set(props.ticks.map((el) => Math.round(el)))];

  return <VictoryLabel {...props} text={roundedTicks.includes(props.datum) ? props.datum : ''} />;
};
